declare var flatpickr: any;

namespace Matrix {

    export interface DateRangeEditorOptions {
        rangeEndProperty: string;
        storeNamedRanges: boolean;
    }

    @Serenity.Decorators.element('<input type="text" />')
    @Serenity.Decorators.registerEditor('Matrix.DateRangeEditor', [Serenity.IGetEditValue, Serenity.ISetEditValue])
    export class DateRangeEditor extends Serenity.Widget<DateRangeEditorOptions>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue {

        private fpElement: JQuery;
        private fp: any;
        private pendingChange: boolean;
        private valueOnOpen: string;

        constructor(element: JQuery, opt: DateRangeEditorOptions) {
            super(element, opt);

            this.fpElement = $('<input type="hidden" class="s-offscreen" />').insertAfter(this.element);
            this.fp = flatpickr(this.fpElement, {
                mode: 'range',
                allowInput: true,
                onChange: (selectedDates) => {
                    this.pendingChange = true;
                    var str = '';
                    if (selectedDates && selectedDates.length) {

                        if (this.options.storeNamedRanges) {
                            var namedRange = getNamedDateRange(selectedDates[0], selectedDates[selectedDates.length - 1]);
                            if (namedRange != null) {
                                this.element.val(namedRange);
                                this.updateDateHint();
                                return;
                            }
                        }

                        str = Q.formatDate(selectedDates[0]);
                        if (selectedDates.length > 1)
                            str += ' - ' + Q.formatDate(selectedDates[1]);
                    }

                    this.element.val(str);
                    this.updateDateHint();
                },
                onClose: () => {
                    lastClose = new Date().getTime();
                    if (this.pendingChange) {
                        this.pendingChange = false;
                        setTimeout(() => {
                            if (Q.trim(this.valueOnOpen) != Q.trim(this.element.val()))
                                this.element.triggerHandler('change');
                        }, 100);
                    }
                },
                onOpen: () => {
                    var range = this.dateRange;
                    if (range == null || range === InvalidDateRange || (range.start == null && range.end == null))
                        this.fp.setDate([], false);
                    else if (range.end == null)
                        this.fp.setDate([range.start, range.start], false);
                    else if (range.start == null)
                        this.fp.setDate([range.end, range.end], false);
                    else
                        this.fp.setDate([range.start, range.end], false);
                    this.valueOnOpen = this.element.val();
                },
                plugins: [
                    predefinedRangesPlugin(namedRanges.map(namedRange => ({
                        label: namedRange,
                        start: parseDateRange(namedRange).start,
                        end: parseDateRange(namedRange).end
                    })))
                ],
                positionElement: this.element[0]
            });

            var lastClose;

            this.element.click(() => {
                if (this.fpElement && this.fpElement.hasClass('active') ||
                    (lastClose && ((new Date().getTime() - lastClose) < 100)))
                    return;
                this.fp && this.fp.open();
            });

            this.element.keyup(() => this.updateDateHint());
        }

        private updateDateHint() {
            var range = this.dateRange;
            if (range?.namedRange &&
                Q.trim(this.element.val() ?? "").toLowerCase() == range.namedRange.toLowerCase()) {
                this.element.attr('title', Q.formatDate(range.start) + ' - ' + Q.formatDate(range.end));
            }
            else
                this.element.attr('title', '');
        }

        public get dateRange(): ParsedDateRange {
            return parseDateRange(this.element.val());
        }

        public set dateRange(value: ParsedDateRange) {
            // todo
        }

        public get startDate(): Date {
            return this.dateRange?.start;
        }

        public get endDate(): Date {
            return this.dateRange?.end;
        }

        public getEditValue(property: Serenity.PropertyItem, target: any): void {
            var range = this.dateRange;
            var empty = range == null || range === InvalidDateRange;

            if (empty)
                target[property.name] = null;

            if (this.options.rangeEndProperty) {
                if (empty)
                    target[this.options.rangeEndProperty] = null;
                else {
                    target[property.name] = Q.formatDate(range.start, 'yyyy-MM-dd');
                    target[this.options.rangeEndProperty] = Q.formatDate(range.end, 'yyyy-MM-dd');
                }
            }

            if (!this.options.rangeEndProperty || this.options.storeNamedRanges) {
                var rangeProp = this.options.rangeEndProperty ? (property.name + '::' + this.options.rangeEndProperty) : property.name;

                if (empty)
                    target[rangeProp] = null;
                else {
                    var namedRange = range.namedRange || getNamedDateRange(range.start, range.end);
                    if (namedRange != null)
                        target[rangeProp] = namedRange;
                    else
                        target[rangeProp] = Q.formatDate(range.start, 'yyyy-MM-dd') + ' - ' + Q.formatDate(range.end, 'yyyy-MM-dd');
                }
            }
        }

        private setFromStr(str: string) {
            var range = parseDateRange(str);
            if (range == null || range === InvalidDateRange || (range.start == null && range.end == null))
                this.element.val('');
            else if (range.start == null)
                this.element.val(Q.formatDate(range.end));
            else if (range.end == null)
                this.element.val(Q.formatDate(range.start));
            else {
                if (this.options.storeNamedRanges) {
                    var namedRange = range.namedRange || getNamedDateRange(range.start, range.end);
                    if (namedRange != null) {
                        this.element.val(namedRange);
                        this.updateDateHint();
                        return;
                    }
                }

                this.element.val(Q.formatDate(range.start) + ' - ' + Q.formatDate(range.end));
            }
            this.updateDateHint();
        }

        public setEditValue(source: any, property: Serenity.PropertyItem): void {

            if (!this.options.rangeEndProperty || this.options.storeNamedRanges) {
                var rangeProp = this.options.rangeEndProperty ? (property.name + '::' + this.options.rangeEndProperty) : property.name;
                var str = source[rangeProp];
                if (str != null) {
                    str = Q.trim(str);
                    if (!str.length) {
                        this.element.val('');
                        return;
                    }

                    this.setFromStr(str);
                    return;
                }
                else if (!this.options.rangeEndProperty) {
                    this.element.val('');
                    return;
                }
            }

            // special case for default value which is passed in start property
            if (!Q.isEmptyOrNull(source[property.name]) &&
                source[this.options.rangeEndProperty] === undefined) {
                this.setFromStr(source[property.name]);
                return;
            }

            str = Q.formatDate(source[property.name]) + ' - ' + Q.formatDate(source[this.options.rangeEndProperty]);
            this.setFromStr(str);
        }
    }

    export interface ParsedDateRange {
        start: Date;
        end: Date;
        namedRange?: string;
    }

    export const InvalidDateRange: ParsedDateRange = {
        start: undefined,
        end: undefined,
    };

    export function firstDayOfWeek(date: Date) {
        return new Date(date.setDate(date.getDate() - date.getDay() +
            (Q.Culture.firstDayOfWeek === 1 ? (date.getDay() == 0 ? -6 : 1) : 0)));
    }

    export function lastDayOfWeek(date: Date) {
        return (new Date(date.setDate(date.getDate() - date.getDay() + 6 + (Q.Culture.firstDayOfWeek || 0))));
    }

    const namedRanges = [
        'Today',
        'Yesterday',
        'This Week',
        'Last Week',
        'Last 7 Days',
        'Last 30 Days',
        'This Month',
        'Last Month',
        'This Quarter',
        'Last Quarter',
        'This Year',
        'Last Year'
    ];

    export function getNamedDateRange(start: Date, end: Date, pivot?: Date): string {

        var date = pivot != null ? new Date(pivot.getTime()) : new Date();
        date.setHours(0, 0, 0, 0);

        if (start == null || end == null)
            return null;

        for (var namedRange of namedRanges) {
            var range = parseDateRange(namedRange, date);
            if (range != null &&
                +range.start === +start &&
                +range.end === +end)
                return namedRange;
        }

        if (+end != +date || start > end)
            return null;

        const utc1 = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
        const utc2 = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate());

        var days = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
        if (days < 365 * 2)
            return 'Last ' + (days + 1) + ' Days';

        return null;
    }

    export function parseDateRange(value: string, pivot?: Date): ParsedDateRange {
        if (value == null)
            return null;

        value = Q.trim(value);
        if (!value.length)
            return null;

        var date = pivot != null ? new Date(pivot.getTime()) : new Date();
        date.setHours(0, 0, 0, 0);

        value = value.toLowerCase();
        switch (value) {
            case 'today':
            case 't':
            case 'td':
                return {
                    start: date,
                    end: date,
                    namedRange: 'Today'
                };

            case 'yesterday':
            case 'y':
            case 'yd':
                date.setDate(date.getDate() - 1);
                return {
                    start: date,
                    end: date,
                    namedRange: 'Yesterday'
                }

            case 'this week':
            case 'thisweek':
            case 'tw':
                return {
                    start: firstDayOfWeek(date),
                    end: lastDayOfWeek(date),
                    namedRange: 'This Week'
                }

            case 'last week':
            case 'lastweek':
            case 'lw':
                date.setDate(date.getDate() - 7);
                return {
                    start: firstDayOfWeek(date),
                    end: lastDayOfWeek(date),
                    namedRange: 'Last Week'
                }

            case 'this month':
            case 'thismonth':
            case 'tm':
                date.setDate(1);
                return {
                    start: date,
                    end: new Date(date.getFullYear(), date.getMonth() + 1, 0),
                    namedRange: 'This Month'
                }

            case 'last month':
            case 'lastmonth':
            case 'lm':
                return {
                    start: new Date(date.getFullYear(), date.getMonth() - 1, 1),
                    end: new Date(date.getFullYear(), date.getMonth(), 0),
                    namedRange: 'Last Month'
                }

            case 'this quarter':
            case 'thisquarter':
            case 'tq':
                var q = Math.floor((date.getMonth() + 3) / 3) - 1;
                return {
                    start: new Date(date.getFullYear(), q * 3, 1),
                    end: new Date(date.getFullYear(), q * 3 + 3, 0),
                    namedRange: 'This Quarter'
                }

            case 'last quarter':
            case 'lastquarter':
            case 'lq':
                var q = Math.floor((date.getMonth() + 3) / 3) - 1;
                var y = date.getFullYear();
                if (q == 0) {
                    q = 3;
                    y -= 1;
                }
                else
                    q -= 1;

                return {
                    start: new Date(y, q * 3, 1),
                    end: new Date(y, q * 3 + 3, 0),
                    namedRange: 'Last Quarter'
                }

            case 'this year':
            case 'thisyear':
            case 'ty':
                return {
                    start: new Date(date.getFullYear(), 0, 1),
                    end: new Date(date.getFullYear() + 1, 0, 0),
                    namedRange: 'This Year'
                }

            case 'last year':
            case 'lastyear':
            case 'ly':
                return {
                    start: new Date(date.getFullYear() - 1, 0, 1),
                    end: new Date(date.getFullYear(), 0, 0),
                    namedRange: 'Last Year'
                }
        }

        var match = /^l(ast)?\s*([0-9]+)\s*d(ay)?s?$/.exec(value);
        if (match) {
            var days = Q.parseInteger(match[2]);
            if (isNaN(days) || days <= 0)
                return InvalidDateRange;

            return {
                start: new Date(date.getFullYear(), date.getMonth(), date.getDate() - days + 1),
                end: date,
                namedRange: days == 1 ? 'today' : ('Last ' + days + ' Days')
            }
        }

        var idx = value.indexOf(' - ');
        if (idx < 0)
            idx = value.indexOf(' -');
        if (idx < 0)
            idx = value.indexOf('- ');

        var d1, d2: any;
        if (idx < 0) {
            var d1 = Q.parseDate(value);
            if (d1 == null)
                return null;

            if (isNaN(d1) || d1 === false)
                return InvalidDateRange;

            return {
                start: d1,
                end: d1
            }
        }
        else {
            var d1str = Q.trim(value.substring(0, idx));
            var d2str = Q.trim(value.substring(idx + 2));
            var d1 = Q.parseDate(d1str);
            var d2 = Q.parseDate(d2str);

            if (d1 == null && d2 == null)
                return null;

            if (isNaN(d1) || d1 === false || isNaN(d2) || d2 === false)
                return InvalidDateRange;

            if (d1 != null)
                d1.setHours(0, 0, 0, 0);
            if (d2 != null)
                d2.setHours(0, 0, 0, 0);

            if (d1 != null && d2 != null && d1 > d2) {
                return {
                    start: d2,
                    end: d1
                }
            }

            return {
                start: d1,
                end: d2
            }
        }
    }
}